import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { HashRouter } from 'react-router-dom';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
const app = (
	<React.Fragment>
		<Suspense
			fallback={<p></p>}
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignContent: 'center',
				alignItems: 'center',
				width: '100%',
				padding: '0 0 0 100px',
				position: 'fixed',
				top: '0',
				left: '0',
			}}
		>
			<HashRouter>
				<App />
			</HashRouter>
		</Suspense>
	</React.Fragment>
);

ReactDOM.render(app, document.getElementById('root'));
